// @flow
'use strict';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';

import CamposBasicos from './campos_basicos';
import CamposCest from './campos_cest';
import CamposOperacao from './campos_operacao';
import CamposIcms from './campos_impostos/campos_icms';
import CamposPis from './campos_impostos/campos_pis';
import CamposCofins from './campos_impostos/campos_cofins';
import CamposImpostoSeletivo from './campos_impostos/campos_imposto_seletivo';
import CamposIbsCbs from './campos_impostos/campos_ibs_cbs';
import CamposDocumentoReferenciado from './campos_documento_referenciado';
import CamposTotalItem from './campos_total_item';

type CampoItemNfceProps = {
  component : React.ComponentType<*>,
}

export default function CampoItemNfce({ component } : CampoItemNfceProps) {
  return (
      <Row>
        <Col md={ 6 }>
          <CamposBasicos component={ component }/>
          <CamposOperacao component={ component }/>
          <CamposCest component={ component }/>
          <CamposIcms component={ component }/>
          <CamposPis component={ component }/>
          <CamposCofins component={ component }/>
        </Col>
        <Col md={ 6 }>
          <CamposImpostoSeletivo component={ component }/>
          <CamposIbsCbs component={ component }/>
          <CamposTotalItem component={ component }/>
          <CamposDocumentoReferenciado component={ component }/>
        </Col>
      </Row>
  );
}